import { Button, useTheme } from '@mui/material';
import { tokens } from '../../theme';
import AddIcon from '@mui/icons-material/Add';


function AddNextButtonTabHeader(props) {

    const { text, onClick } = props

    const theme = useTheme()
    const colors = tokens(theme.palette.mode)


    return (
        <Button
            sx={{ backgroundColor: colors.assigned.button1 }}
            size='small'
            variant="contained"
            onClick={onClick}
            startIcon={<AddIcon />}
        >
            {text}
        </Button>
    )
}

export default AddNextButtonTabHeader